import { ErrorLog } from "@elite/vue-logging";

const errorLog = new ErrorLog();

export { errorLog };
